// Mock data for Elite Marriage Lawns website

export const heroData = {
  headline: "Celebrate Love at Elite Marriage Lawns",
  subheadline: "Allaganj's Premier Destination for Timeless Weddings & Events",
  ctaText: "Book Your Date",
  backgroundImage: "https://images.unsplash.com/photo-1574482211311-45a2169db57c?w=1920&q=80"
};

export const aboutData = {
  title: "About Elite Marriage Lawns",
  description: "Nestled in the heart of Allaganj, Uttar Pradesh, Elite Marriage Lawns offers the perfect blend of luxury and nature for your most cherished celebrations. Our sprawling green lawns, elegant décor options, and world-class amenities create an unforgettable backdrop for weddings, receptions, and special events.",
  features: [
    "Spacious, beautifully landscaped gardens",
    "Accessible location for all guests",
    "Personalized event planning assistance",
    "Commitment to making your dreams come true"
  ],
  image: "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?w=800&q=80"
};

export const amenitiesData = [
  {
    id: 1,
    title: "Spacious Green Lawn",
    description: "Expansive, beautifully manicured lawns perfect for grand celebrations",
    icon: "Trees"
  },
  {
    id: 2,
    title: "Luxury Bridal Rooms",
    description: "Elegantly appointed dressing rooms for the bride and groom",
    icon: "Crown"
  },
  {
    id: 3,
    title: "Ample Parking Space",
    description: "Convenient parking facilities for hundreds of vehicles",
    icon: "Car"
  },
  {
    id: 4,
    title: "In-house Catering Support",
    description: "Professional catering services with customizable menus",
    icon: "UtensilsCrossed"
  },
  {
    id: 5,
    title: "Power Backup",
    description: "Uninterrupted power supply for worry-free celebrations",
    icon: "Zap"
  },
  {
    id: 6,
    title: "Dual Event Hosting",
    description: "Unique capability to host two weddings simultaneously",
    icon: "Users"
  }
];

export const galleryData = {
  categories: ["All", "Weddings", "Receptions", "Parties"],
  images: [
    {
      id: 1,
      src: "gallery/WhatsApp Image 2026-01-24 at 3.38.17 PM (1).jpeg",
      category: "Weddings",
      alt: "Beautiful wedding mandap setup"
    },
    {
      id: 2,
      src: "gallery/WhatsApp Image 2026-01-24 at 3.38.17 PM (2).jpeg",
      category: "Weddings",
      alt: "Traditional Indian wedding decoration"
    },
    {
      id: 3,
      src: "gallery/WhatsApp Image 2026-01-24 at 3.38.17 PM.jpeg",
      category: "Receptions",
      alt: "Luxury reception hall"
    },
    {
      id: 4,
      src: "gallery/WhatsApp Image 2026-01-24 at 3.38.18 PM (1).jpeg",
      category: "Receptions",
      alt: "Elegant dinner setup with fairy lights"
    },
    {
      id: 5,
      src: "gallery/WhatsApp Image 2026-01-24 at 3.38.18 PM (2).jpeg",
      category: "Weddings",
      alt: "Grand wedding hall"
    },
    {
      id: 6,
      src: "gallery/WhatsApp Image 2026-01-24 at 3.38.18 PM.jpeg",
      category: "Parties",
      alt: "Garden party setup"
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1768777270882-9f74939fee50?w=600&q=80",
      category: "Receptions",
      alt: "Sunset reception tables"
    },
    {
      id: 8,
      src: "https://images.pexels.com/photos/19870036/pexels-photo-19870036.jpeg?w=600&q=80",
      category: "Parties",
      alt: "Elegant event setup"
    }
  ]
};

export const testimonialsData = [
  {
    id: 1,
    name: "Priya & Rahul Sharma",
    event: "Wedding, December 2024",
    quote: "Elite Marriage Lawns made our dream wedding a reality. The venue was absolutely stunning, and the staff went above and beyond to ensure everything was perfect. Highly recommended for anyone looking for the best wedding lawn in Allaganj!",
    rating: 5
  },
  {
    id: 2,
    name: "Anita & Vikram Gupta",
    event: "Reception, November 2024",
    quote: "We couldn't have asked for a better venue for our reception. The spacious lawns, beautiful lighting, and excellent catering made our celebration unforgettable. Thank you, Elite Marriage Lawns!",
    rating: 5
  },
  {
    id: 3,
    name: "Meera & Aditya Singh",
    event: "Wedding, October 2024",
    quote: "From the moment we visited Elite Marriage Lawns, we knew it was the perfect place for our wedding. The team was professional, accommodating, and helped us create magical memories.",
    rating: 5
  },
  {
    id: 4,
    name: "Sunita & Deepak Verma",
    event: "Anniversary Party, September 2024",
    quote: "We celebrated our 25th anniversary at Elite Marriage Lawns and it was spectacular! The venue's elegance and the team's attention to detail made our celebration truly special.",
    rating: 5
  }
];

export const contactData = {
  email: "rudravir12@gmail.com",
  phone: "7607837676",
  address: "Infront of Vivekananda Inter College, NH 730C, Allaganj, Uttar Pradesh 242220",
  mapUrl: "https://maps.app.goo.gl/XkUbY8GXF8QmR6CE6",
  socialLinks: {
    instagram: "#",
    facebook: "#"
  }
};

export const logoUrl = "https://customer-assets.emergentagent.com/job_51f94975-7bb4-473d-acae-2da6fa648be5/artifacts/8una90a8_ChatGPT%20Image%20Jan%2024%2C%202026%2C%2001_05_17%20PM.png";
